import { RefNumRequirement } from 'lib/api/getRefNumRequirements';
import { NormalizedLoad } from 'types/Load';
import { ManualFieldError } from 'utils/formValidation';

export function mapQualifierToField(qualifier: string) {
  const name = qualifier.trim().toLowerCase();
  if (
    name.includes('purchase order') ||
    name === 'po' ||
    name.includes('po number')
  ) {
    return 'poNums' as const;
  }
  if (
    name.includes('bill of lading') ||
    name === 'bol' ||
    name.includes('b/l')
  ) {
    return 'customer.refNumber' as const;
  }
  return null;
}

export function validateThreeGReferences(
  data: NormalizedLoad,
  requirements: RefNumRequirement[]
): ManualFieldError<NormalizedLoad>[] {
  const errors: ManualFieldError<NormalizedLoad>[] = [];
  const refs = data.additionalReferences || [];
  for (const requirement of requirements.filter((r) => r.isRequiredForOrder)) {
    const field = mapQualifierToField(requirement.qualifier);
    const index = refs.findIndex(
      (ref) =>
        ref.qualifierId === requirement.qualifierId ||
        ref.qualifier.trim().toLowerCase() ===
          requirement.qualifier.trim().toLowerCase()
    );
    let value: string | null | undefined = refs[index]?.number;
    if (field === 'poNums') value = data.poNums;
    if (field === 'customer.refNumber') value = data.customer?.refNumber;
    if (!value?.trim()) {
      errors.push({
        path:
          field ||
          (index >= 0
            ? `additionalReferences.${index}.number`
            : 'additionalReferences'),
        message: `${requirement.qualifier} is required for this customer`,
      });
    }
  }
  refs.forEach((ref, index) => {
    if (
      ref.number?.trim() &&
      (!Number.isInteger(ref.qualifierId) || (ref.qualifierId ?? 0) <= 0)
    ) {
      errors.push({
        path: `additionalReferences.${index}.qualifierId`,
        message: 'Select a valid reference type',
      });
    }
  });
  return errors;
}
